<script setup lang="ts">
    /**
     * @deprecated use Highlights Widget Container
     *
     * Highlights Widget Container
     * contains a list of HighlightsWidgets or ProductWidgets (the same except for the award property)
     */
    const props = defineProps<IWidgetProps<HighlightsContainerData>>();

    const { data, getValueSequence, cmsComponentProps } = useWidget(props);

    // validate data here and perform additional async calls if required
    const sequence = getValueSequence(data.value);
</script>
<template>
    <lazy-org-highlights-container
        :sequence="sequence"
        v-bind="cmsComponentProps" />
</template>
